import { useEffect } from 'react';
import { ShipperPlatformIds } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useShipperPlatformIds(uuid: string) {
  const shipper = useAxios(
    (axios, signal, uuid: string) =>
      axios.request<ShipperPlatformIds>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shippers/platform-ids/${uuid}`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    shipper.execute(uuid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  return shipper;
}

export type ShipperPlatformIdsRequest = ReturnType<
  typeof useShipperPlatformIds
>;
